export default "__VITE_ASSET__BC56NuBy__"